/* eslint-disable react/no-array-index-key */
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import Divider from '@zenbusiness/zui/Divider';
import Grid from '@zenbusiness/zui/Grid';
import IconButton from '@zenbusiness/zui/IconButton';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './Display.styles';

const Display = ({ title: titleProp, sections, onClose }) => {
  const { formatMessage: fm } = useIntl();
  const title = titleProp || fm({ id: 'orderView.items.heading' });

  return (
    <Styled.Root>
      <DialogTitle>
        <Grid alignItems="center" container>
          <Grid item xs>
            <Text variant="h6">{title}</Text>
          </Grid>
          <Grid item>
            <IconButton label={fm({ id: 'orderView.items.close' })} onClick={onClose} size="large" clickstreamProps={{ elementName: 'order_view_details_close_button' }}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Divider />
      </DialogTitle>
      <DialogContent>
        {sections
          .filter(({ filter }) => filter !== false)
          .map(({ title: sectionTitle, items }, i) => (
            <Styled.Section key={i}>
              <Styled.SectionTitle variant="subtitle2" fontWeight="bold">
                {sectionTitle}
              </Styled.SectionTitle>
              <Styled.SectionContent container>
                {items.map(({ content, label, ...props }, j) => (
                  <Grid
                    item
                    sx={{ padding: '1rem' }}
                    {...props}
                    key={j}
                  >
                    <Styled.ItemTitle variant="body2">{label}</Styled.ItemTitle>
                    {content}
                  </Grid>
                ))}
              </Styled.SectionContent>
            </Styled.Section>
          ))}
      </DialogContent>
    </Styled.Root>
  );
};

Display.propTypes = {
  title: PropTypes.string,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      filter: PropTypes.bool,
      items: PropTypes.arrayOf(PropTypes.shape({}))
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired
};

export default Display;
